<template>
  <div
    class="flex p-10"
    :class="reminder.bgColor"
  >
    <div class="flex items-center mr-16">
      <div class="icon-big">
        <i :class="reminder.icon" />
      </div>
    </div>

    <div class="flex flex-col">
      <p class="text-3xl mb-5">
        <b>{{ reminder.title }}</b>
      </p>

      <router-link :to="{ name: 'my@schedule' }">
        <p class="text-2xl mb-5">
          <b>
            Click here to view your schedule
          </b>
        </p>
      </router-link>

      <p class="text-2xl mb-0">
        {{ reminder.footer }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    reminder: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style lang="scss"></style>
